import { render, staticRenderFns } from "./TipoCapacitacionPage.vue?vue&type=template&id=270fe6fa"
import script from "./TipoCapacitacionPage.js?vue&type=script&lang=js&external"
export * from "./TipoCapacitacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports